import Vue from 'vue';
import VueI18n from 'vue-i18n';

import it from './it';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'it',
  messages: { it },
});

export default i18n;
